import { z } from 'zod'

export const bindSandboxAccountSchema = z.object({
  tbankAccountId: z.string().min(1),
})
export type BindSandboxAccountDto = z.infer<typeof bindSandboxAccountSchema>
